
export interface ChartBoxPosition {
    readonly left: string;
    readonly right: string;
}

export function ChartBox(left: string | number, right: string | number): ChartBoxPosition {
    const leftPos = (typeof left === "number") ? `${left}%` : left;
    const rightPos = (typeof right === "number") ? `${right}%` : `calc(100% - ${right})`;
    return {left: leftPos, right: rightPos};
}
